import { useEffect, useRef, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import * as api from '~/fetch';

export const useUpdateLocale = () => {
  const [showSpinner, setShowSpinner] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const mutation = useMutation({
    mutationFn: async (locale: string) => {
      const response = await api.user.updateLocale(locale);
      return api.utils.processResponse(response, {
        200: () => ({ success: true }),
        default: () => {
          throw new Error('Failed to update locale');
        },
      });
    },
    onSuccess: () => {
      window.location.reload();
    },
    onError: () => {
      toast.error('Could not update language.');
    },
  });

  useEffect(() => {
    if (mutation.isPending) {
      timeoutRef.current = setTimeout(() => setShowSpinner(true), 2000);
    } else {
      clearTimeout(timeoutRef.current);
      setShowSpinner(false);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [mutation.isPending]);

  return { ...mutation, showSpinner };
};
